import { err, ErrorKind, Result } from "./result";

type Handler<T> = (data: { [key: string]: any }) => Result<T>;

type Handlers<T> = { [key: string]: Handler<T> };

export default async function <T>(
  url: string,
  handlers: Handlers<T>,
): Promise<Result<T>> {
  while (true) {
    let response;
    try {
      response = await fetch(url);
    } catch (error) {
      return err(ErrorKind.FetchError, error);
    }
    if (!response.ok) {
      return err(ErrorKind.ServerError, response);
    }
    let data;
    try {
      data = await response.json();
    } catch (error) {
      return err(ErrorKind.JSONError, error);
    }
    if (typeof data.status !== "string") {
      return err(ErrorKind.MalformedMessage, data);
    }
    const handler = handlers[data.status];
    if (handler !== undefined) {
      return handler(data);
    }
    switch (data.status) {
      case "pending":
        continue;
      case "timeout":
        return err(ErrorKind.Timeout);
      default:
        return err(ErrorKind.UnknownMessage, data);
    }
  }
}
